module.exports = __webpack_public_path__ + "static/media/picky_flyer_lg.bd927584.jpg";